/**
 * Collection Spaces – scroll-triggered viewport animation.
 * Animates 4 corner images from section center outward to grid positions.
 * Uses IntersectionObserver (20% visibility), runs once per section.
 */
(function() {
  'use strict';

  function initSection(sectionEl) {
    var grid = sectionEl.querySelector('.collection-spaces__grid');
    var corners = sectionEl.querySelectorAll('.collection-spaces__corner');
    if (!grid || !corners.length) return;

    function setInitialState() {
      var sectionRect = sectionEl.getBoundingClientRect();
      var scX = sectionRect.left + sectionRect.width / 2;
      var scY = sectionRect.top + sectionRect.height / 2;
      for (var i = 0; i < corners.length; i++) {
        var corner = corners[i];
        var r = corner.getBoundingClientRect();
        var cx = r.left + r.width / 2;
        var cy = r.top + r.height / 2;
        var tx = scX - cx;
        var ty = scY - cy;
        corner.style.transform = 'translate(' + tx + 'px, ' + ty + 'px)';
        corner.classList.add('collection-spaces__corner--animate');
      }
    }

    setInitialState();

    var observer = new IntersectionObserver(function(entries) {
      for (var k = 0; k < entries.length; k++) {
        if (!entries[k].isIntersecting) continue;
        var target = entries[k].target;
        var els = target.querySelectorAll('.collection-spaces__corner');
        for (var j = 0; j < els.length; j++) {
          els[j].style.transform = 'translate(0, 0)';
        }
        observer.unobserve(target);
      }
    }, { threshold: 0.2 });

    observer.observe(sectionEl);
  }

  function run() {
    var sections = document.querySelectorAll('.section-collection-spaces .collection-spaces');
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      requestAnimationFrame(function() {
        requestAnimationFrame(run);
      });
    });
  } else {
    requestAnimationFrame(function() {
      requestAnimationFrame(run);
    });
  }
})();
